import { EMBED_CAPABLE_PRODUCTS } from './constants';

/**
 * Extracts the hostname from a URL string.
 * Returns undefined if the URL is invalid.
 */
export const extractUrlHostname = (sourceUrl: string): string | undefined => {
	let url;
	try {
		url = new URL(sourceUrl);
	} catch {
		return undefined;
	}
	return url.hostname;
};

/**
 * Check if a URL belongs to an embed-capable product based on its domain.
 */
export function isEmbedCapableUrl(url: string): boolean {
	if (!url) {
		return false;
	}
	const hostname = extractUrlHostname(url);
	if (!hostname) {
		return false;
	}
	return EMBED_CAPABLE_PRODUCTS.some(({ urlPatterns }) =>
		urlPatterns.some((pattern) => hostname === pattern || hostname.endsWith(`.${pattern}`)),
	);
}
